<template>
  <div class="board">
    <Card
      v-for="(card, index) in cards"
      v-bind:animal="card"
      v-bind:index="index"
      v-bind:covered="isCovered(index)"
      v-bind:handleClick="tryCard"
      v-bind:key="index"
    />
  </div>
</template>

<script>
import Card from "./components/Card";
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(["cards", "isCovered"])
  },
  methods: {
    ...mapActions(["tryCard"])
  },
  components: {
    Card
  }
};
</script>

<style scoped>
.board {
  width: 300px;
  height: 300px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  margin: 0 auto;
}
</style>
